import React, { useRef, useState, useEffect } from "react";

import BoiReactMarkdown from "../../boi-markdown/boi-markdown";
import Container from "./container";
import StyledCheckbox from "./styled/checkbox";
import StyledTextArea from "./styled/textarea";

import { iControlProps, iChoice } from "../types";

export type TermsOfServiceProps = iControlProps & {
    id: string;
    name: string;
    type: string;
    isRequired: boolean;
    choices: iChoice[];
    inputs: { id: string; label: string; name: string }[];
    gwtermsofservice_terms?: string;
    gwtermsofservice_require_scroll?: boolean;
};

const TermsOfService = ({
    name,
    choices,
    inputs,
    gwtermsofservice_terms: terms,
    gwtermsofservice_require_scroll: requireScroll,
    onChange,
    ...props
}: TermsOfServiceProps) => {
    const choice = choices[0];
    const termsInput = useRef<HTMLTextAreaElement>(document.createElement("textarea"));
    const [disabledCheckbox, setDisabledCheckbox] = useState(true);
    const choiceSelected = props.value && !!Object.keys(props.value).length;

    useEffect(() => {
        if (!requireScroll
            || (requireScroll && !termsInput.current)
            || (requireScroll
                && termsInput.current.clientHeight === termsInput.current.scrollHeight)) {
                setDisabledCheckbox(false);
            }
    }, [requireScroll]);

    return (
        <Container {...props}>
            <StyledTextArea
                id={`${props.id}_content`}
                ref={termsInput}
                defaultValue={terms}
                readOnly={true}
                className="terms-of-service"
                onScroll={() => {
                    termsInput.current.clientHeight + termsInput.current.scrollTop
                        === termsInput.current.scrollHeight && setDisabledCheckbox(false);
                }}
                aria-label="Terms of service content"
            />
            <StyledCheckbox className={"checkbox"}>
                <div className={disabledCheckbox ? "checkbock-disabled" : ""}>
                    <input
                        checked={choiceSelected}
                        type="checkbox"
                        name={name}
                        id={`${props.id}_checkbox`}
                        value={name}
                        disabled={disabledCheckbox}
                        onChange={() => {
                            const value = !choiceSelected
                                ? { [inputs[0].id]: choice.value }
                                : {};
                            onChange && onChange(value);
                        }}
                    />
                    <label
                        className="field-label"
                        htmlFor={`${props.id}_checkbox`}>
                        <BoiReactMarkdown
                            disallowedElements={["p"]}
                            unwrapDisallowed={true}
                        >
                            {choice.text}
                        </BoiReactMarkdown>
                    </label>
                </div>
            </StyledCheckbox>
        </Container>
    );
};

TermsOfService.defaultProps = {
    choices: []
};

export default TermsOfService;
